<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
  <div>
    <h3 class="m-0">Nuovo cliente</h3>
    <p class="m-0 text-muted">Clicca su una scheda per espanderne il contenuto</p>
  </div>

  <div class="hidden-mobile">
    <button
      mat-stroked-button
      type="button"
      (click)="openDialog()"
      matTooltip="Registra un nuovo cliente rapidamente, compilando solo i dati essenziali."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
      class="izy-button-ghost custom-button-border"
    >
      <mat-icon>bolt</mat-icon>
      Aggiunta rapida
    </button>
  </div>
</div>

<!-- mobile version -->
<div class="visible-mobile mt-2 w-100 mb-3">
  <button
    mat-stroked-button
    type="button"
    (click)="openDialog()"
    matTooltip="Registra un nuovo cliente rapidamente, compilando solo i dati essenziali."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    class="w-100 izy-button-ghost custom-button-border"
  >
    <mat-icon>bolt</mat-icon>
    Aggiunta rapida
  </button>
</div>

<p class="ms-1 small text-muted">
  I campi contrassegnati da * sono obbligatori.
</p>

<div class="form-container">
  <form #CompanyForm="ngForm" (ngSubmit)="addNewCompany()" class="company-form">

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      [expanded]="true"
      #panel
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Cliente
        </mat-panel-title>
        <mat-panel-description>
          {{ newCompany.company_name ? newCompany.company_name : 'Nuovo cliente' }}
          <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Nome cliente</mat-label>
          <input
            matInput
            [(ngModel)]="newCompany.company_name"
            name="company_name"
            matTooltip="La ragione sociale dell'azienda o il nome e cognome della persona che stai registrando."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Tipo</mat-label>
          <mat-select
            class="izy-select-trigger"
            panelClass="izy-select-panel izy-select-panel--form"
            [(ngModel)]="newCompany.type"
            name="type"
            matTooltip="Il tipo di soggetto che stai registrando. Determina alcuni controlli sui dati fiscali."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            required
          >
            <mat-option *ngFor="let type of typeOptions" [value]="type.code">
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>P. IVA</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.iva_number"
            name="iva_number"
            minlength="11"
            maxlength="11"
            pattern="[0-9]*"
            (ngModelChange)="onPartitaIvaChange($event)"
            (input)="onPartitaIvaInput($event)"
            (blur)="validatePartitaIva(newCompany.iva_number)"
            matTooltip="La Partita IVA del cliente (11 cifre). Devi indicare almeno uno fra Partita IVA e Codice Fiscale."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            #iva_numberInput="ngModel"
          />
          <mat-error *ngIf="iva_numberInput.invalid && (iva_numberInput.dirty || iva_numberInput.touched)">
            La Partita Iva deve essere composta esattamente da 11 cifre
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Codice Fiscale</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.c_f"
            name="c_f"
            maxlength="16"
            pattern="([A-Z0-9]{11}|[A-Z0-9]{16})"
            matTooltip="Il Codice Fiscale del cliente (11 o 16 caratteri). Devi indicare almeno uno fra Partita IVA e Codice Fiscale."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            #CFInput="ngModel"
          />
          <mat-error *ngIf="CFInput.invalid && (CFInput.dirty || CFInput.touched)">
            Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Codice destinatario SDI</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.addressee_code"
            name="addressee_code"
            required
            minlength="6"
            maxlength="7"
            pattern="^[A-Z0-9]*"
            matTooltip="Il codice SDI a cui vengono recapitate le fatture elettroniche del cliente. Se non lo conosci, usa 0000000."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            #SDI_CodeInput="ngModel"
          />
          <mat-error *ngIf="SDI_CodeInput.invalid && (SDI_CodeInput.dirty || SDI_CodeInput.touched)">
            Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Codice interno (opzionale)</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.internal_code"
            name="internal_code"
            matTooltip="Un codice tuo, per ritrovare più facilmente il cliente nelle ricerche."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          />
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl"
      [expanded]="true"
      #panel2
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Dati anagrafici
        </mat-panel-title>
        <mat-panel-description>
          {{ newCompany.city ? newCompany.city : 'Indirizzo' }}{{ newCompany.province ? ' (' + newCompany.province + ')' : '' }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Indirizzo</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.address"
            name="address"
            matTooltip="Via e numero civico della sede del cliente."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Città</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.city"
            name="city"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Comune</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.comune"
            name="comune"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>CAP</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.cap"
            name="cap"
            required
            minlength="5"
            maxlength="5"
            pattern="[0-9]*"
            matTooltip="Il codice di avviamento postale (5 cifre)."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            #CAP_CodeInput="ngModel"
          />
          <mat-error *ngIf="CAP_CodeInput.invalid && (CAP_CodeInput.dirty || CAP_CodeInput.touched)">
            Il CAP deve essere composto esattamente da 5 cifre
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Provincia (sigla)</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="newCompany.province"
            name="province"
            required
            minlength="2"
            maxlength="2"
            pattern="[A-Z]*"
            (ngModelChange)="onProvinceChange($event)"
            (input)="onProvinceInput($event)"
            (blur)="validateProvince(newCompany.province)"
            matTooltip="La sigla della provincia, in due lettere maiuscole (es. MI, RM)."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            #provinceInput="ngModel"
          />
          <mat-error *ngIf="provinceError">
            {{ provinceError }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Nazione</mat-label>
          <mat-select
            class="izy-select-trigger"
            panelClass="izy-select-panel izy-select-panel--form"
            [(ngModel)]="newCompany.country"
            name="country"
            required
          >
            <mat-option *ngFor="let country of countryOptions" [value]="country.code">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Telefono</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.telephone"
            name="telephone"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Cellulare</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.cellphone"
            name="cellphone"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.email_address"
            name="email_address"
            matTooltip="L'indirizzo email a cui potrai inviare le fatture di questo cliente."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>PEC</mat-label>
          <input
            matInput
            type="string"
            [(ngModel)]="newCompany.pec"
            name="pec"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note (opzionali)</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="6"
            type="string"
            [(ngModel)]="newCompany.notes"
            name="notes"
            matTooltip="Annotazioni per uso interno: non compaiono sui documenti emessi al cliente."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          ></textarea>
        </mat-form-field>
      </div>

      <!-- .hidden-mobile impone display:block, quindi l'allineamento a destra
           passa da text-end (il pulsante e' inline-flex) e non da flexbox. -->
      <div class="text-end hidden-mobile">
        <button
          mat-raised-button
          matButton="filled"
          type="submit"
          [disabled]="!CompanyForm.valid"
          class="mt-2 primary-button custom-button-border"
          matTooltip="Salva il cliente nella tua anagrafica."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <mat-icon>person_add</mat-icon>
          Aggiungi cliente
        </button>
      </div>
      <!-- mobile version -->
      <div class="visible-mobile">
        <button
          mat-raised-button
          matButton="filled"
          type="submit"
          [disabled]="!CompanyForm.valid"
          class="w-100 mt-2 primary-button custom-button-border"
          matTooltip="Salva il cliente nella tua anagrafica."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <mat-icon>person_add</mat-icon>
          Aggiungi cliente
        </button>
      </div>
    </mat-expansion-panel>

  </form>
</div>

<div class="pt-3 mb-3"></div>
